import { Features } from "@/common/providers/feature-provider";
import { PlanSchema } from "@/common/services/user";
import { Nullable } from "@/types";

type FeatureMode = "trial" | "full" | "not-available";

const getFeatureMode = (
  companyPlan: Nullable<PlanSchema["planId"]>,
  feature: Features[keyof Features],
): FeatureMode => {
  if (!feature) {
    return "not-available";
  }

  if (companyPlan === null) {
    return "full";
  }

  if (companyPlan !== feature.planId) {
    return "trial";
  }

  return "full";
};

export { getFeatureMode };
export type { FeatureMode };
